<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="rows"
			class="tablaLT1 issues"
			item-key="id"
    	:expanded.sync="expanded"
      show-expand
			:class="dark_t?'dark':''">
			<template v-slot:item="props">
				<tr style="vertical-align: top;">
					<td>
						<v-icon @click="expand(props.item)">
							{{isExpanded(props.item) ? 'expand_more': 'chevron_right'}}
						</v-icon>
					</td>
					<td style="text-align:left !important"><fs1-span>{{ props.item.finding_code }}</fs1-span></td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.old_finding_creation_date }}</fs1-span></td>
					<td style="text-align:left !important"><fs1-span>{{ props.item.critical_asset_name }}</fs1-span></td>
					<!-- <td style="text-align:left !important"><fs1-span>{{ props.item.functional_location }}</fs1-span></td> -->
					<!-- <td style="text-align:center !important"><fs1-span>{{ props.item.financial_impact }}</fs1-span></td> -->
					<!-- <td style="text-align:center !important"><fs1-span>{{ props.item.severity_level_1 }}</fs1-span></td> -->
					<!-- <td style="text-align:center !important"><fs1-span>{{ props.item.likelihood }}</fs1-span></td> -->
					<!-- <td style="text-align:center !important"><fs1-span>{{ props.item.rrr }}</fs1-span></td> -->
					<!-- <td style="text-align:center !important"><fs1-span>{{ props.item.priority_action_1 }}</fs1-span></td> -->
					<td style="text-align:left !important"><fs1-span>{{ props.item.action }}</fs1-span></td>
					<td style="text-align:left !important">
						<div>
							<div v-for="(val, i) in split_text(props.item.mitigation_plan_in_place)" :key="i">
								<fs1-span>{{ val }}</fs1-span>
							</div>
							<fs1-span v-if="!props.item.mitigation_plan_in_place"><!-- N/A --></fs1-span>
						</div>
					</td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.responsible_area }}</fs1-span></td>

					<td style="text-align:center !important"><fs1-span>{{ props.item.remediation_date }}</fs1-span></td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.remediation_status }}</fs1-span></td>

					<td :style="`background-color:${colors[props.item.priority]};text-align:center !important;color:black`"><fs1-span>{{ props.item.priority }}</fs1-span></td>
					<!-- <td><fs1-span>{{ props.item.critical_asset_organization }}</fs1-span></td>
					
					<td style="text-align:left !important"><fs1-span>{{ props.item.technical_report }}</fs1-span></td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.financial_impact }}</fs1-span></td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.severity_level_1 }}</fs1-span></td>
					<td style="text-align:center !important"><fs1-span>{{ props.item.priority_action_2 }}</fs1-span></td>
					 -->
				</tr>
			</template>
			<template v-slot:expanded-item="{headers, item}">
				<td :colspan="headers.length">
					<div v-for="(val, i) in subHeaders" :key="i+'ll'">
						<fieldset  class="subFields" :class="dark_t?'dark':''" v-if="val.text === 'Hallazgos Cálculos Finitos' ? item[val.value] : true">
							<legend><fs1-span><b>{{val.text}}:</b></fs1-span></legend>
							<div>
								<div v-for="(val, i) in split_text(item[val.value])" :key="i">
									<fs1-span>{{ val }}</fs1-span>
								</div>
								<fs1-span v-if="!item[val.value]">N/A</fs1-span>
							</div>
						</fieldset>
					</div>
				</td>
			</template>
			<template v-slot:no-data>
					<v-icon>warning</v-icon>
					Sin Información.
			</template>
		</v-data-table>
	</div>
</template>

<script>
import moment from 'moment';

export default {
  props:{
		data: {
      require: true,
      default: () => []
		},
		colors: {}
	},
  data() {
    return {
			expanded:[],
			console,
		};
  },
  computed: {
    headers() {
      return [
				{ text: 'Código', value: 'finding_code'},
				{ text: 'Fecha de Creación',  value: 'old_finding_creation_date'},
				{ text: 'Activos Criticos',  value: 'critical_asset_name'},
				/* { text: 'Functional location',  value: 'functional_location'}, */
				/* { text: 'MFL financiero',  value: 'financial_impact'}, */
				/* { text: 'Severity factor',  value: 'severity_level_1'}, */
				/* { text: 'Likelyhood',  value: 'likelihood'}, */
				/* { text: 'RRR',  value: 'rrr'}, */
				/* { text: 'Priority',  value: 'priority_action_1'}, */
				{ text: 'Acción de Remediación',  value: 'action'},
				{ text: 'Planes Mitigadores in Place',  value: 'mitigation_plan_in_place'},
				{ text: 'Area Responsable',  value: 'responsible_area'},
				{ text: 'Fecha de Remediación',  value: 'remediation_date'},
				{ text: 'Estatus de Remediación',  value: 'remediation_status'},
				{ text: 'Priority',  value: 'priority'}, 
				/* { text: 'Área',  value: 'critical_asset_organization', class:'width150px'},
				
				{ text: 'Acción Asset Integrity',  value: 'asset_integrity_action'},
				
				{ text: 'Impacto Financiero',  value: 'financial_impact'},
				{ text: 'Severity Level',  value: 'severity_level_1'},
				{ text: 'Priority Action',  value: 'priority_action_2'},
				*/
      ];
    },
		subHeaders() {
			return [
				/* { text: 'Hallazgos Especialidad Estructural', value: 'structural_discovery' },
				{ text: 'Hallazgos Especialidad SPCI', value: 'spci_discovery' },
				{ text: 'Hallazgos Especialidad Mecánica', value: 'mechanical_discovery' },
				{ text: 'Hallazgos Especialidad Elétrica', value: 'electrical_discovery' },
				{ text: 'Hallazgos Cálculos Finitos', value: 'ea_discovery' }, */
				{ text: 'Functional location',  value: 'functional_location'},
				{ text: 'Proceso', value: 'process' },
				{ text: 'Reporte técnico',  value: 'technical_report'},
				{ text: 'Descripción Hallazgo', value: 'description', class:'width50p' },
			]
		},
    rows() { return this.data || [] }
  },
  methods: {
    expand(item){
      this.isExpanded(item)
        ? this.expanded.splice(this.expanded.indexOf(item),1)
        : this.expanded.push(item);
    },
    isExpanded(item) { return this.expanded.indexOf(item) > -1},
		getCompletePColor(a){
			if (a < 30) return 'red';
			if (a < 59)  return 'orange';
			if (a < 89) return 'yellow';
			if (a < 101) return 'green';
			console.error(a)
		},
  }, // methods
};
</script>

<style scoped>
.completePercentColor{
	text-align: center !important;
	height: 100%;
}
.-red{
	background-color: #ff7b7b !important;
}
.-yellow{
	background-color: #ffff9d !important;
}
.-orange{
	background-color: #de5b03 !important;
}
.-green{
	background-color: #5e9c5e !important;
}

.issues td{
  text-align: justify !important;
  text-justify: inter-word !important;
}
</style>